import axios from 'axios';

import { Reel } from '@/types/reel.type';
import { logDebug } from '@/util/log.util';
import { useSetReelByCode } from '@/store/library/library.hook';

import { useInteractiveCallback } from './useInteractiveCallback';

// NOTE: Refreshes the cached reel in the background. Unlike
//   clearReelByCode(), it keeps the current reel on screen, so the flyover
//   doesn't flash a loading state.
export function useRefetchReel() {
    const setReelByCode = useSetReelByCode();

    return useInteractiveCallback(async (reelCode: string) => {
        try {
            if (!reelCode) {
                throw new Error('Reel code is required');
            }

            const { data } = await axios.get<{ reel: Reel }>(
                route('api.internal.reels.show', { code: reelCode }),
            );

            setReelByCode(reelCode, data.reel);
        } catch (ex) {
            logDebug(`[useRefetchReel] Error refetching reel ${reelCode}`, ex);
        }
    });
}
